export type MemberKind = "human" | "agent" | "app";

export function memberKind(userId: string): MemberKind {
  const localpart = /^@([^:]+):/.exec(userId)?.[1] ?? "";
  if (localpart.startsWith("_agent_")) return "agent";
  if (
    localpart.startsWith("_webhooks_") ||
    localpart === "hookshot" ||
    localpart.startsWith("_github_")
  ) {
    return "app";
  }
  return "human";
}
